import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReasonsService } from './logic/reasons.service';
import { ReasonsLogicService } from './logic/reasons/reasons-logic.service';
import { ReasonsDaoService } from './dao/reasons-dao.service';
import { ReasonsDbDaoService } from './dao/reasons-dao/reasons-db-dao.service';
import { ReasonDbTableDefinition } from './dao/reasons-dao/reason-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: ReasonsService, useClass: ReasonsLogicService },
    { provide: ReasonsDaoService, useClass: ReasonsDbDaoService },
    { provide: ReasonDbTableDefinition },
  ]
})
export class ReasonsModule {}
